<template>
  <div :id="'productGroup_'+ categoryNum + productGroupNum">
    <template v-if="productGroups.description && passgroupType !== 'one' && passgroupType !=='package'">
      <div class="ticket-pack" style="color: #3887ff">
        {{productGroups.productgroup_name}}
      </div>
      <div class="ticket-description" >
        {{ productGroups.description }}
      </div>
    </template>
    <popup-products :products="productGroups.products"
                    :productUserCount="productGroups.concurrency_count"
                    :productColor="productColor"
                    :productGroupNum="''+categoryNum+'_'+productGroupNum"
                    :passgroup-type="passgroupType"
                    :contentId="contentId"
                    :contentType="contentType" :current-index="currentIndex"
                    :package-detail-map="packageDetailMap"
                    :key="'currentIndex_' + currentIndex"/>
  </div>
</template>

<script>
import PopupProducts from '@/components/voucher/PopupProducts'

export default {
  components: {
    PopupProducts
  },
  props: {
    packageDetailMap: {
      type: Object
    },
    productGroups: {
      type: Object,
      required: true
    },
    categoryNum: {
      type: Number,
      required: true
    },
    productGroupNum: {
      type: Number,
      required: true
    },
    passgroupType: {
      type: String,
      required: true
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String
    },
    currentIndex: {
      type: String
    }
  },
  data () {
    return {
      productColor: ''
    }
  }
}
</script>
